var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Checkbox, Grid, Select } from 'semantic-ui-react';
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { Pmol, PredefinedLabel } from "../automated-pro/RnaCatalog";
import { priceColumn } from "./EditKitForm";
import { FreeTextAmpLabel, } from "./KitModel";
import { ComponentPriceDisplay } from "./ProbeSetForm";
var HcrAmplifierForm = /** @class */ (function (_super) {
    __extends(HcrAmplifierForm, _super);
    function HcrAmplifierForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.priceDisplay = function () {
            return React.createElement(ComponentPriceDisplay, { effectivePriceCents: _this.props.effectivePriceCents, listPriceCents: _this.props.listPriceCents, loading: _this.props.priceLoading });
        };
        _this.onScaleChange = function (_, data) {
            var v = data.value;
            var newScale = _this.currentScales().find(function (s) { return s.valuePmol === v; });
            if (newScale === undefined) {
                if (!_this.props.enableCustomScale) {
                    throw new RangeError("Unknown scale value " + v);
                }
                if (typeof v !== 'string') {
                    throw new Error("Invalid scale " + v);
                }
                var num = parseInt(v, 10);
                if (num === undefined || isNaN(num)) {
                    throw new Error("Invalid scale " + v);
                }
                newScale = new Pmol(num);
            }
            _this.props.onAmpStateChange({
                scale: newScale
            }, _this.props.onUserSelection);
        };
        _this.onLabelChange = function (_, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new RangeError("Unexpected label value type: " + val);
            }
            var currentAmpLabelCatalog = _this.props.catalog.channels.find(function (a) { return a.hcrAmplifier.id === _this.props.ampState.hcrAmplifier.id; });
            if (currentAmpLabelCatalog == null) {
                throw new Error("Unexpected amplifier value type: " + _this.props.ampState.hcrAmplifier.id);
            }
            if (val.startsWith('id:')) {
                var idStr_1 = val.substring('id:'.length);
                var labels = _this.props.enableAdminSystems ? currentAmpLabelCatalog.labels.combined.concat(currentAmpLabelCatalog.labels.admin) : currentAmpLabelCatalog.labels.combined;
                var newLabel = labels
                    .find(function (l) { return l.label.id === idStr_1; });
                if (newLabel === undefined) {
                    throw new RangeError("Unknown label value " + val);
                }
                var oldScale_1 = _this.props.ampState.scale;
                var update = void 0;
                // if the scale exists for the new label
                if (newLabel.scales.findIndex(function (s) { return s.valuePmol === oldScale_1.valuePmol; }) >= 0) {
                    // then use it
                    update = {
                        label: newLabel.label,
                    };
                }
                else {
                    // we transitioned from custom, or otherwise from a scale that this label doesn't support
                    var scale = void 0;
                    if (["B6", "B7", "B8", "B9", "B10"].includes(_this.props.ampState.hcrAmplifier.id)) {
                        scale = _this.props.catalog.freeTextLabelScales[0];
                    }
                    else {
                        scale = newLabel.defaultScale;
                    }
                    update = {
                        label: newLabel.label,
                        scale: scale
                    };
                }
                _this.props.onAmpStateChange(update, _this.props.onUserSelection);
            }
            // if it's not an id, someone added a new entry; onAddFreeTextLabel will be called
        };
        _this.onAddFreeTextLabel = function (event, data) {
            if (typeof data.value !== 'string') {
                return;
            }
            var label = new FreeTextAmpLabel(data.value);
            _this.props.onAmpStateChange({
                label: label,
                // default to first custom label scale option
                scale: _this.props.catalog.freeTextLabelScales[0]
            }, _this.props.onUserSelection);
        };
        _this.onToggleAdminSystems = function (_) {
            var hcrAmplifier = _this.props.ampState.hcrAmplifier;
            var label = _this.props.ampState.label;
            var catalog = _this.props.catalog.channels.find(function (a) {
                return a.hcrAmplifier.id === hcrAmplifier.id;
            });
            if (catalog === undefined) {
                throw new RangeError("Invalid amplifier " + _this.props.ampState.hcrAmplifier.id);
            }
            // When the amplifier is admin only (X11-X20), we default to the default amplifier and label.
            if (catalog.admin) {
                hcrAmplifier = _this.props.catalog.defaultChannel.hcrAmplifier;
                label = _this.props.catalog.defaultChannel.defaultLabel.label;
                catalog = _this.props.catalog.defaultChannel;
            }
            // When toggling admin systems off (or on), if the current label is admin-only or a user-provided free-text label,
            // reset it to the catalog default so the resulting state remains valid for the new adminSystems setting.
            if (label instanceof PredefinedLabel && catalog.labels.admin.some(function (l) {
                return l.label.id === label.id;
            }) || label instanceof FreeTextAmpLabel) {
                label = catalog.defaultLabel.label;
            }
            _this.props.onAmpStateChange(function (oldState) {
                return {
                    adminSystems: !oldState.adminSystems,
                    hcrAmplifier: hcrAmplifier,
                    label: label
                };
            }, _this.props.onUserSelection);
        };
        _this.onAmplifierChange = function (_, data) {
            var valStr = data.value;
            var catalog = _this.props.catalog.channels.find(function (a) {
                return a.hcrAmplifier.id === valStr;
            });
            if (catalog === undefined) {
                throw new RangeError("Invalid amplifier " + valStr);
            }
            var update;
            if (["B6", "B7", "B8", "B9", "B10"].includes(catalog.hcrAmplifier.id)) {
                var scale = _this.props.catalog.freeTextLabelScales
                    .find(function (s) { return s.valuePmol === _this.props.ampState.scale.valuePmol; });
                update = scale ? {
                    hcrAmplifier: catalog.hcrAmplifier,
                    label: catalog.defaultLabel.label
                } :
                    {
                        hcrAmplifier: catalog.hcrAmplifier,
                        scale: _this.props.catalog.freeTextLabelScales[0],
                        label: catalog.defaultLabel.label
                    };
            }
            else {
                update = { hcrAmplifier: catalog.hcrAmplifier, label: catalog.defaultLabel.label };
            }
            _this.props.onAmpStateChange(update, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onAmpStateChange(function (oldState) { return ({ customPrice: newStateFn(oldState.customPrice) }); }, callback);
        };
        _this.currentScales = function () {
            var _a, _b, _c;
            var label = _this.props.ampState.label;
            var ampSixToTen = ["B6", "B7", "B8", "B9", "B10"].includes(_this.props.ampState.hcrAmplifier.id);
            var scales;
            // Fall back to the catalog default rather than throwing: a transient amp/label mismatch (e.g. an
            // encoder toggle that invalidates the current amp) must not white-page the form.
            var catalog = (_a = _this.props.catalog.channels.find(function (a) {
                return a.hcrAmplifier.id === _this.props.ampState.hcrAmplifier.id;
            })) !== null && _a !== void 0 ? _a : _this.props.catalog.defaultChannel;
            if (label instanceof FreeTextAmpLabel || ampSixToTen) {
                scales = _this.props.catalog.freeTextLabelScales;
            }
            else {
                scales = (_c = (_b = (_this.props.ampState.adminSystems
                    ? catalog.labels.combined.concat(catalog.labels.admin)
                    : catalog.labels.combined).find(function (l) {
                    return l.label.id === label.id;
                })) === null || _b === void 0 ? void 0 : _b.scales) !== null && _c !== void 0 ? _c : catalog.defaultLabel.scales;
            }
            // don't mess with the arrays in the catalog
            scales = Array.from(scales);
            if (_this.props.enableCustomScale) {
                // if custom things are allowed, create an extra entry if need be
                if (scales.findIndex(function (p) { return p.valuePmol === _this.props.ampState.scale.valuePmol; }) < 0) {
                    scales.push(new Pmol(_this.props.ampState.scale.valuePmol));
                }
            }
            scales.sort(function (s1, s2) { return s1.valuePmol - s2.valuePmol; });
            return scales;
        };
        return _this;
    }
    HcrAmplifierForm.labelValue = function (l) {
        if (l instanceof FreeTextAmpLabel) {
            return "free-text:" + l.name;
        }
        return "id:" + l.id;
    };
    HcrAmplifierForm.prototype.render = function () {
        var _this = this;
        var _a;
        var scaleOptions = this.currentScales().map(function (s) {
            var numberOfSamples = calculateNumOfSamplesForAmp(s.valuePmol);
            var numberOfSlides = calculateNumOfSlidesForAmp(s.valuePmol);
            var volumeLabel = _this.props.legacy ? s.valueWithUnit : s.ampConcentratedWithUnit;
            if (_this.props.selectedSampleType.id === 'WHOLE_MOUNT' || _this.props.selectedSampleType.id === 'CELLS_SUSPENSION') {
                return {
                    text: React.createElement(React.Fragment, null,
                        numberOfSamples,
                        " samples",
                        React.createElement("span", { className: "description" }, volumeLabel)),
                    content: React.createElement(React.Fragment, null,
                        numberOfSamples,
                        " samples",
                        React.createElement("span", { className: "description" }, volumeLabel)),
                    value: s.valuePmol
                };
            }
            else if (_this.props.selectedSampleType.id === 'TISSUE_SECTION' || _this.props.selectedSampleType.id === 'CELLS_SLIDE') {
                return {
                    text: React.createElement(React.Fragment, null,
                        numberOfSlides,
                        " slides",
                        React.createElement("span", { className: "description" }, volumeLabel)),
                    content: React.createElement(React.Fragment, null,
                        numberOfSlides,
                        " slides",
                        React.createElement("span", { className: "description" }, volumeLabel)),
                    value: s.valuePmol
                };
            }
            else {
                return {
                    text: React.createElement(React.Fragment, null, volumeLabel),
                    content: React.createElement(React.Fragment, null, volumeLabel),
                    value: s.valuePmol
                };
            }
        });
        var freeTextOption = [];
        if (this.props.ampState.label instanceof FreeTextAmpLabel && this.props.ampState.adminSystems) {
            freeTextOption.push({
                text: this.props.ampState.label.name,
                value: HcrAmplifierForm.labelValue(this.props.ampState.label)
            });
        }
        var labelLabel = this.props.encoder ? React.createElement(React.Fragment, null,
            "Label ",
            React.createElement(Help, null,
                React.createElement("p", null, "For multiplex experiments, choose a different label (647, 546, \u2026) for each amplifier that will be imaged in the same sample (e.g., X3-647, X2-546, \u2026)."),
                React.createElement("p", null, "For flexibility, 488, 546, 594, and 647 are available across all X1-X10 systems. For expanded channel options, select amplifiers also offer an additional unique label option. We recommend using a longer-wavelength label (e.g., 647 or 750) for targets that are more difficult to detect (e.g., low-expression targets), as autofluorescence tends to be higher in shorter-wavelength channels (e.g., 405 or 488)."))) :
            this.props.secondaryIf ? React.createElement(React.Fragment, null,
                "Label ",
                React.createElement(Help, null,
                    React.createElement("p", null, "For multiplex experiments, choose a different label (647, 546, \u2026) for each amplifier that will be imaged in the same sample (e.g., X3-647, X2-546, \u2026)."),
                    React.createElement("p", null, "For flexibility, 488, 546, 594, and 647 are available across all X1-X10 systems. For expanded channel options, select amplifiers also offer an additional unique label option. We recommend using a longer-wavelength label (e.g., 647 or 750) for targets that are more difficult to detect (e.g., low-expression targets), as autofluorescence tends to be higher in shorter-wavelength channels (e.g., 405 or 488)."))) :
                this.props.legacy ? React.createElement(React.Fragment, null,
                    "Label ",
                    React.createElement(Help, null,
                        React.createElement("p", null, "For multiplex experiments, choose a different fluorophore label (647, 594, \u2026) for each HCR\u2122 Amplifier (v3.0) that will be imaged in the same sample (e.g., B1-647, B2-594, \u2026)."))) : React.createElement(React.Fragment, null,
                    "Label ",
                    React.createElement(Help, null,
                        React.createElement("p", null, "For multiplex experiments, choose a different label (647, 546, \u2026) for each amplifier that will be imaged in the same sample (e.g., X3-647, X2-546, \u2026)."),
                        React.createElement("p", null, "For flexibility, 488, 546, 594, and 647 are available across all X1-X10 systems. For expanded channel options, select amplifiers also offer an additional unique label option. We recommend using a longer-wavelength label (e.g., 647 or 750) for targets that are more difficult to detect (e.g., low-expression targets), as autofluorescence tends to be higher in shorter-wavelength channels (e.g., 405 or 488).")));
        var scaleLabel = this.props.legacy ? React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "The standard reaction concentration of each HCR\u2122 Amplifier (v3.0) hairpin is 60 nM. The HCR\u2122 Amplifier (v3.0) scale depends on the reaction volume and the number of experiments. For example, for a 100 \u03BCL reaction volume, each experiment will require 6 pmol of each hairpin, so 600 pmol amplifier scale corresponds to 100 experiments.",
                React.createElement("br", null),
                React.createElement("br", null),
                "For the following sample types, recommended reaction volumes are:",
                this.props.experimentVolumeTable)) : React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "The default HCR\u2122 Gold Amplifier scale is 200 \u00B5L.  For different sample types, representative reaction volumes and corresponding amplifier scale and number of experiments are:",
                this.props.experimentVolumeTable));
        // Fall back to the catalog default rather than throwing: during a transient state (e.g. an
        // encoder species swap that invalidates the current amp) the selected amp may briefly not be
        // in this catalog, and throwing here would white-page the whole app.
        var currentAmpLabelCatalog = (_a = this.props.catalog.channels.find(function (c) {
            return c.hcrAmplifier.id === _this.props.ampState.hcrAmplifier.id;
        })) !== null && _a !== void 0 ? _a : this.props.catalog.defaultChannel;
        var labelOptions = freeTextOption
            .concat((this.props.ampState.adminSystems ? currentAmpLabelCatalog.labels.combined.concat(currentAmpLabelCatalog.labels.admin) : currentAmpLabelCatalog.labels.combined)
            .sort(function (a, b) { return a.label.name.localeCompare(b.label.name); })
            .map(function (l) { return ({
            // match left spacing from custom icon
            text: React.createElement(React.Fragment, null,
                React.createElement("span", null, l.label.name)),
            content: React.createElement(React.Fragment, null,
                React.createElement("span", null, l.label.name)),
            value: HcrAmplifierForm.labelValue(l.label),
        }); }));
        var amplifierDropdownText = function () {
            return _this.props.catalog.channels.filter(function (a) {
                // When the admin systems toggle is disabled, filter out the admin only X11-X20 amplifiers
                if (!_this.props.ampState.adminSystems) {
                    return !a.admin;
                }
                else {
                    return true;
                }
            }).map(function (a) {
                return {
                    text: React.createElement(React.Fragment, null,
                        a.hcrAmplifier.id,
                        React.createElement("span", { className: "description" }, !_this.props.legacy && React.createElement(CompatibleLabels, { labels: a.labels }))),
                    value: a.hcrAmplifier.id
                };
            });
        };
        return React.createElement(Grid, { columns: 4, stackable: true },
            this.props.enableAdminSystems && !this.props.legacy &&
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Checkbox, { checked: this.props.ampState.adminSystems, onChange: this.onToggleAdminSystems, label: "Enable custom amplifiers" }))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/hcrAmplifier', errors: this.props.errors, labelContent: this.props.amplifierLabel, labelFor: 'amp-hcr-amplifier', showErrors: this.props.showErrors },
                        React.createElement(Select, { className: "label-dropdown amp-dropdown", value: this.props.ampState.hcrAmplifier.id, onChange: this.onAmplifierChange, options: amplifierDropdownText(), name: 'amp-hcr-amplifier' }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/label', errors: this.props.errors, labelContent: labelLabel, labelFor: 'amp-label', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'amp-label', className: labelOptions.length <= 1 ? "deactivated-dropdown" : "selection-dropdown", onChange: this.onLabelChange, options: labelOptions, value: HcrAmplifierForm.labelValue(this.props.ampState.label), search: true, scrolling: false, additionLabel: 'Custom Label: ', additionPosition: "bottom", allowAdditions: this.props.ampState.adminSystems, onAddItem: this.props.ampState.adminSystems ? this.onAddFreeTextLabel : undefined, icon: labelOptions.length <= 1 ? false : undefined }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/scalePmol', errors: this.props.errors, labelContent: scaleLabel, labelFor: 'amp-scale', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'amp-scale', className: "label-dropdown", value: this.props.ampState.scale.valuePmol, allowAdditions: this.props.enableCustomScale, onChange: this.onScaleChange, options: scaleOptions, search: true }))),
                priceColumn(this.priceDisplay(), this.props.effectivePriceCents !== this.props.listPriceCents)),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.ampState.customPrice, defaultEffectivePriceCents: this.props.effectivePriceCents, errorPathPrefix: '/amplifierComponent', errors: this.props.errors, onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    return HcrAmplifierForm;
}(React.PureComponent));
export { HcrAmplifierForm };
export var calculateNumOfSamplesForAmp = function (valuePmol) {
    return Math.floor(valuePmol / 12);
};
export var calculateNumOfSlidesForAmp = function (valuePmol) {
    return Math.round(valuePmol / 6);
};
/**
 * Renders an amplifier's compatible labels (standard and extended together) as one flat
 * comma-separated list in ascending numeric order, all in the muted .description grey. 633 is
 * deliberately omitted from this summary — it remains selectable in the label dropdown itself.
 */
export var CompatibleLabels = function (_a) {
    var labels = _a.labels;
    var names = labels.standard.concat(labels.extended)
        .map(function (l) { return l.label.name; })
        .filter(function (n) { return n !== "633"; })
        .sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
    return React.createElement(React.Fragment, null, names.join(", "));
};
/**
 * so 200µL of probe -> 200pmol -> 50 samples so probes is pmol / 4
 * For amps it’s
 * 600 pmol -> 50 samples so amps is pmol / 12
 */ 
//# sourceMappingURL=HcrAmplifierForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/HcrAmplifierForm.js
// module id = 128
// module chunks = 0